import { AxiosResponseHeaders } from "axios";
import saveAs from "file-saver";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useExportInvoiceHistoryToExcelMutation } from "../../../api/services/client/clientApis";
import { ProgramProjectInvoiceType } from "../../../api/services/common/models";
import { toggleLoader } from "../../../redux/slices/appState/appStateSlice";
import { getFileNameFromHeader } from "../../reports/helper";

export const useExportInvoiceHistoryToExcel = () => {
  const dispatch = useDispatch();
  const {
    mutateAsync: exportInvoiceHistoryToExcel,
    isPending: isExportInvoiceHistoryPending,
  } = useExportInvoiceHistoryToExcelMutation();

  useEffect(() => {
    dispatch(
      toggleLoader({
        isInvoiceHistoryToExcelPending: {
          isVisible: isExportInvoiceHistoryPending,
        },
      }),
    );
    return () => {
      dispatch(
        toggleLoader({ isInvoiceHistoryToExcelPending: { isVisible: false } }),
      );
    };
  }, [isExportInvoiceHistoryPending]);

  const downloadExcel = async (
    invoiceId: string,
    type: ProgramProjectInvoiceType,
  ) => {
    const response = await exportInvoiceHistoryToExcel({
      invoiceId,
      type,
    });
    const filename = getFileNameFromHeader(
      response.headers as AxiosResponseHeaders,
    );
    saveAs(response.data, filename);
  };

  return {
    downloadExcel,
  };
};
